export default __webpack_public_path__ + "static/media/duster-techroad-small.f0bbfd42.jpg";